export default __webpack_public_path__ + "6a2ff17d94a8e90a4ff13e00089f0dc1.jpg";